<template>
  <div>
    <v-card class="mr-13">
      <v-toolbar color="primary" dark shaped>
        <v-toolbar-title>Listado de Empresa-Condición</v-toolbar-title>
        <v-spacer></v-spacer>
        <div class="mr-16">
          <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar"
              shaped
              single-line
              hide-details
          ></v-text-field>
        </div>
        <v-btn
            color="secondary"
            absolute
            top
            right
            fab
            @click="toogleForm"
            :disabled="showForm"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table
          :headers="header"
          :items="econdiciones"
          :search="search"
          :loading="loading"
          loading-text="Cargando... Espere porfavor"
          @change="loadData"
          no-data-text="No existen Empresa-Condiciones registrados en el sistema."
          :item-key="econdiciones.id"

      >
        <template v-slot:body="props" >
          <tbody name="slide" is="transition-group" mode="out-in" appear>
          <template >
            <tr v-for="(item, index) in props.items" :key="item.id">
              <td>{{index+1}}</td>
              <td>{{item.empresa.nombre}}</td>
              <td>{{item.condicion.nombre}}</td>
              <td>{{item.opcion ? item.opcion.nombre : "-"}}</td>
              <td>
                <TableAction :item="item" @update="toogleForm" @delaction="deleteItem"/>
              </td>
            </tr>
          </template>
          </tbody>
        </template>

      </v-data-table>
    </v-card>
    <template>
      <empresa-condicion-form v-if="showForm" :title="title" :show-form="showForm"
                    :econdicion="editItem" @close="toogleForm" />
    </template>
    <template>
      <v-dialog persistent max-width="200" transition="dialog-top-transition" v-if="menuLocked" v-model="menuLocked">
        <v-card>
          <v-card-title>Eliminar</v-card-title>
          <v-card-text>Seguro que desea eliminar
            {{itemToDelete.empresa.nombre + " " + itemToDelete.condicion.nombre + " " + itemToDelete.opcion.nombre}}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                color="terciary"
                text
                @click="deleteItemCancel"
                icon
            >
              <v-icon>mdi-cancel</v-icon>
            </v-btn>
            <v-spacer></v-spacer>

            <v-btn
                color="secondary"
                text
                @click="deleteItemConfirm"
                icon
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

  </div>
</template>

<script>
import TableAction from "../../components/TableAction";
import EmpresaCondicionForm from "../../components/EmpresaCondicion/EmpresaCondicionForm";
import {mapGetters} from "vuex";

export default {
  name: "EmpresaCondicionList",
  components: {TableAction, EmpresaCondicionForm},
  data:()=>({
    loading: false,
    showForm: false,
    search: '',
    title:'',
    defaultEditItem: null,
    editItem: null,
    itemToDelete: null,
    menuLocked: false,
    deleteConfirmId: '',
    header: [
      { text: 'No', value: 'num', sortable: false },
      { text: 'Empresa', value: 'econdiciones.empresa.nombre' },
      { text: 'Condición', value: 'econdiciones.condicion.nombre' },
      { text: 'Opción', value: 'econdiciones.opcion.nombre' },
      { text: 'Acciones', value: 'actions', sortable: false },
    ],
  }),
  mounted() {
    if(this.econdiciones.length<=0){
      this.loadData()
    }
  },
  computed: {
    ...mapGetters(['econdiciones']),
  },
  methods: {
    async loadData() {
      this.loading = true;
      await this.$store.dispatch("allEmpresaCondiciones");
      await this.$store.dispatch("allEmpresas");
      await this.$store.dispatch("allCondiciones");
      await this.$store.dispatch("allOpciones");
      this.loading = false;
    },
    toogleForm(item){
      this.econdiciones.indexOf(item)=== -1 ? (this.editItem= {}, this.title='Nuevo Empresa-Condición') :
          (this.editItem = {...item}, this.title='Actualizar Empresa-Condición');
      this.showForm = ! this.showForm;
    },

    deleteItem(item) {
      this.itemToDelete = item
      this.menuLocked = true

    },

    async deleteItemConfirm() {
      if (this.itemToDelete !== null) {
        await this.$store.dispatch("deleteEmpresaCondicion", this.itemToDelete);
        this.menuLocked = false;
        this.itemToDelete = null;

      }
    },

    deleteItemCancel() {
      this.menuLocked = false
      this.itemToDelete = null
    },
  },
}
</script>

<style scoped>
.slide-enter-active {
  animation: slide-in 1s ease-out forwards;
}
.slide-live-active {
  animation: slide-out 1s ease-out forwards;
}
@keyframes slide-in {
  from {
    transform: translateY(-30px);
  } to {
      transform: translateY(0);
    }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  } to {
      transform: translateY(-30px);
    }
}
</style>
